/*
 * @Author: fusiyuan 1152054863@qq.com
 * @Date: 2025-08-19 16:06:52
 * @LastEditors: fusiyuan 1152054863@qq.com
 * @LastEditTime: 2025-08-19 16:38:57
 * @FilePath: \slbq-web\management-side\src\config\request.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import axios from "axios";
import { requestUrl } from "./config";
import { Message } from "element-ui";
import router from "@/router";

const api = axios.create({
  baseURL: requestUrl,
  timeout: 15000,
  headers: {
    "Content-Type": "application/json",
    // Authorization: "Bearer your_token_here",
  },
});

api.interceptors.request.use(
  (config) => {
    // Retrieve the token from local storage or any other storage
    const token = sessionStorage.getItem("token");
    console.log("token:", token);
    // If the token exists, add it to the headers
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }

    return config;
  },
  (error) => {
    // Do something with request error
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response) => {
    // 响应拦截器
    return response;
  },
  (error) => {
    // 响应错误处理
    if (error.code === "ECONNABORTED") {
      console.log("请求超时！");
      // 处理超时逻辑
    } else if (error.response) {
      switch (error.response.status) {
        case 401:
          // 清除本地存储的token
          sessionStorage.removeItem("token");
          // Message.error("登录已过期，请重新登录");
          // 1秒后跳转到登录页面
          setTimeout(() => {
            router.push("/login");
          }, 1000);
          break;
        case 500:
          Message.error(`服务器错误`);
          break;
      }
    }
    return Promise.reject(error);
  }
);

// GET请求
api.get = (url, params = {}) => {
  return api({
    method: "get",
    url,
    params,
  });
};

// POST请求
api.post = (url, data = {}, config) => {
  return api({
    method: "post",
    url,
    data,
    ...config, // 合并自定义配置
  });
};

export default api;
